import axios from "axios";
import config from "@/lib/config";
import { getAuthToken } from "@/lib/authStorage";

export const getUserData = async () => {
  try {
    const token = getAuthToken();
    const response = await axios.get(`${config.loginUrl}/users/get-user-data`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
